(function () {
	const YOUTUBE_POSTMESSAGE_ORIGINS = ["https://www.youtube.com", "https://www.youtube-nocookie.com"];
	const DESKTOP_VIDEO_QUERY = window.matchMedia("(min-width: 1025px)");

	function syncHomeSlideshowHeader(activeSlideEl) {
		if (!document.body.classList.contains("template-index")) return;

		const overlayHeader = document.querySelector(".header.overlay");
		if (!overlayHeader) return;

		const firstSection = document.querySelector("main section:first-of-type");
		if (!firstSection || !firstSection.classList.contains("slideshow-section")) return;

		const useWhiteHeader =
			activeSlideEl && activeSlideEl.getAttribute("data-slide-has-video") === "true";

		overlayHeader.classList.remove("header--slideshow-white", "header--slideshow-light");

		if (useWhiteHeader) {
			overlayHeader.classList.add("header--slideshow-white");
			return;
		}

		overlayHeader.classList.add("header--slideshow-light");
	}

	window.syncHomeSlideshowHeader = syncHomeSlideshowHeader;

	function postToYoutubeIframes(rootEl, commandFunc) {
		rootEl.querySelectorAll(".js-slideshow-youtube-iframe").forEach(function (iframe) {
			const payload = JSON.stringify({
				event: "command",
				func: commandFunc,
				args: "",
			});
			YOUTUBE_POSTMESSAGE_ORIGINS.forEach(function (origin) {
				try {
					iframe.contentWindow.postMessage(payload, origin);
				} catch (e) {}
			});
		});
	}

	const slideshow = () => {
		$(".slideshow-section").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			$(this).addClass("slider_started");
			const id = $(this).attr("id");
			const box = $(this).find(".slideshow");
			const autoplay = box.data("autoplay");
			const stopAutoplay = box.data("stop-autoplay");
			const delay = box.data("delay") * 1000;
			const slideCount = box.data("count");
			const loop = slideCount == 1 ? false : true;

			let staticTimer = null;
			let videoFallbackTimer = null;
			let videoAbortController = null;
			let hoverPaused = false;
			let pendingAdvance = false;
			let activeVideo = null;

			function clearSlideAdvanceTimers() {
				if (staticTimer) {
					clearTimeout(staticTimer);
					staticTimer = null;
				}
				if (videoFallbackTimer) {
					clearTimeout(videoFallbackTimer);
					videoFallbackTimer = null;
				}
			}

			function clearActiveVideoHandlers() {
				if (videoAbortController) {
					videoAbortController.abort();
					videoAbortController = null;
				}
				activeVideo = null;
			}

			function isVideoVisible(video) {
				if (!video) return false;
				const style = window.getComputedStyle(video);
				return (
					style.display !== "none" &&
					style.visibility !== "hidden" &&
					video.offsetWidth > 0 &&
					video.offsetHeight > 0
				);
			}

			function pauseAllSlideshowVideos(rootEl) {
				rootEl.querySelectorAll(".js-slideshow-background-video").forEach(function (video) {
					video.pause();
				});
			}

			function prepareVideoElement(video) {
				video.loop = false;
				video.muted = true;
				video.defaultMuted = true;
				video.playsInline = true;
				video.setAttribute("muted", "true");
				video.setAttribute("playsinline", "true");
				video.setAttribute("webkit-playsinline", "true");
				video.setAttribute("disablepictureinpicture", "true");
				if (video.preload !== "auto") {
					video.preload = "auto";
				}
			}

			function getActiveSlideVideo(slide) {
				if (!slide) return null;

				const mobileVideo = slide.querySelector(
					".js-slideshow-background-video.mobile-only"
				);
				const desktopVideo = slide.querySelector(
					".js-slideshow-background-video:not(.mobile-only)"
				);
				const candidates = DESKTOP_VIDEO_QUERY.matches
					? [desktopVideo, mobileVideo]
					: [mobileVideo, desktopVideo];

				for (let i = 0; i < candidates.length; i++) {
					if (isVideoVisible(candidates[i])) {
						return candidates[i];
					}
				}

				return candidates.find(Boolean) || null;
			}

			function advanceSlide(swiper) {
				if (hoverPaused) {
					pendingAdvance = true;
					return;
				}

				pendingAdvance = false;
				if (slideCount <= 1) return;
				swiper.slideNext();
			}

			function scheduleStaticAdvance(swiper, timeout) {
				clearSlideAdvanceTimers();
				staticTimer = setTimeout(function () {
					advanceSlide(swiper);
				}, timeout);
			}

			function playActiveSlideVideo(swiper, slide) {
				const video = getActiveSlideVideo(slide);
				if (!video) return false;

				clearActiveVideoHandlers();
				clearSlideAdvanceTimers();
				activeVideo = video;
				videoAbortController = new AbortController();
				const signal = videoAbortController.signal;

				prepareVideoElement(video);

				let hasAdvanced = false;
				let hasStarted = false;
				const doAdvance = function () {
					if (hasAdvanced) return;
					hasAdvanced = true;
					clearSlideAdvanceTimers();
					advanceSlide(swiper);
				};

				const scheduleDurationTimer = function () {
					const durationMs = video.duration * 1000;
					if (!Number.isFinite(durationMs) || durationMs <= 0) return;

					clearSlideAdvanceTimers();
					videoFallbackTimer = setTimeout(doAdvance, durationMs + 200);
				};

				const startVideo = function () {
					scheduleDurationTimer();
					video.currentTime = 0;

					const attemptPlay = function (retry) {
						const playPromise = video.play();
						if (playPromise === undefined) return;

						playPromise.catch(function () {
							if (retry > 0) {
								setTimeout(function () {
									attemptPlay(retry - 1);
								}, 300);
								return;
							}

							scheduleStaticAdvance(swiper, delay);
						});
					};

					attemptPlay(2);
				};

				const onVideoReady = function () {
					if (hasStarted) return;
					hasStarted = true;
					startVideo();
				};

				video.addEventListener("ended", doAdvance, { signal });
				video.addEventListener("timeupdate", function () {
					if (!Number.isFinite(video.duration) || video.duration <= 0) return;
					if (video.currentTime >= video.duration - 0.25) {
						doAdvance();
					}
				}, { signal });

				video.load();

				if (video.readyState >= 1 && Number.isFinite(video.duration) && video.duration > 0) {
					onVideoReady();
				} else {
					video.addEventListener("loadedmetadata", onVideoReady, { once: true, signal });
					video.addEventListener("loadeddata", onVideoReady, { once: true, signal });
					video.addEventListener("canplay", onVideoReady, { once: true, signal });

					setTimeout(function () {
						if (!hasAdvanced && video.paused) {
							onVideoReady();
						}
					}, 400);
				}

				return true;
			}

			function scheduleActiveSlide(swiper) {
				if (!autoplay || slideCount <= 1) return;

				clearSlideAdvanceTimers();
				clearActiveVideoHandlers();

				const activeSlide = swiper.slides[swiper.activeIndex];
				if (!activeSlide) return;

				pauseAllSlideshowVideos(swiper.el);

				if (
					activeSlide.getAttribute("data-slide-has-video") === "true" &&
					playActiveSlideVideo(swiper, activeSlide)
				) {
					return;
				}

				const hasYoutube = activeSlide.querySelector(".js-slideshow-youtube-iframe");
				if (hasYoutube) {
					playActiveSlideshowYoutube(swiper);
				}

				scheduleStaticAdvance(swiper, delay);
			}

			let swiperParms = {
				parallax: true,
				spaceBetween: 0,
				speed: box.data("speed") * 1000,
				loop: loop,
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: true,
				},
			};
			const swiper = new Swiper(`#${id} .slideshow__swiper`, swiperParms);

			function pauseSlideshowYoutube(rootEl) {
				postToYoutubeIframes(rootEl, "pauseVideo");
			}

			function playActiveSlideshowYoutube(context) {
				const activeSlide = context.slides[context.activeIndex];
				if (!activeSlide) return;
				const iframe = activeSlide.querySelector(".js-slideshow-youtube-iframe");
				if (!iframe) return;
				const payload = JSON.stringify({
					event: "command",
					func: "playVideo",
					args: "",
				});
				YOUTUBE_POSTMESSAGE_ORIGINS.forEach(function (origin) {
					try {
						iframe.contentWindow.postMessage(payload, origin);
					} catch (e) {}
				});
			}

			function syncYoutubeWrapVisibility(swiperInstance) {
				const $root = $(swiperInstance.el);
				$root.find(".slideshow__video-wrap").addClass("slideshow__video-wrap--inactive");
				const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
				if (activeSlide) {
					$(activeSlide)
						.find(".slideshow__video-wrap")
						.removeClass("slideshow__video-wrap--inactive");
				}
			}

			function handleSlideChangeStart(context) {
				$(context.el).find(".slideshow__video-wrap").addClass("slideshow__video-wrap--inactive");
				pauseSlideshowYoutube(context.el);
				pauseAllSlideshowVideos(context.el);
				clearSlideAdvanceTimers();
				clearActiveVideoHandlers();
				pendingAdvance = false;
			}

			function handleSlideChangeEnd(context) {
				syncYoutubeWrapVisibility(context);
				playActiveSlideshowYoutube(context);
				colorScheme(context);
				scheduleActiveSlide(context);
			}

			function bootSlideshow(swiper) {
				syncYoutubeWrapVisibility(swiper);
				playActiveSlideshowYoutube(swiper);
				scheduleActiveSlide(swiper);
			}

			colorScheme(swiper);
			swiper.on("beforeTransitionStart", function () {
				colorScheme(this);
			});
			swiper.on("slideChangeTransitionStart", function () {
				handleSlideChangeStart(this);
			});
			swiper.on("slideChangeTransitionEnd", function () {
				handleSlideChangeEnd(this);
			});

			if (stopAutoplay && autoplay) {
				box.on("mouseenter", function () {
					hoverPaused = true;
					clearSlideAdvanceTimers();
				});
				box.on("mouseleave", function () {
					hoverPaused = false;
					if (pendingAdvance) {
						advanceSlide(swiper);
						return;
					}
					scheduleActiveSlide(swiper);
				});
			}

			DESKTOP_VIDEO_QUERY.addEventListener("change", function () {
				if (!autoplay) return;
				scheduleActiveSlide(swiper);
			});

			document.addEventListener("visibilitychange", function () {
				if (!autoplay || document.visibilityState !== "visible") return;
				scheduleActiveSlide(swiper);
			});

			let slideshowBooted = false;
			swiper.on("init", function () {
				if (slideshowBooted) return;
				slideshowBooted = true;
				bootSlideshow(this);
			});

			if (swiper.initialized && !slideshowBooted) {
				slideshowBooted = true;
				bootSlideshow(swiper);
			}

			function colorScheme(context) {
				const activeIndex = context.activeIndex;
				const activeSlide = context.slides[activeIndex];
				const changeItems = [
					context.navigation.nextEl,
					context.navigation.prevEl,
					context.pagination.el,
				];
				const colorScheme = $(activeSlide)
					.find(".slideshow-slide")
					.data("color-scheme");
				changeItems.forEach((item) => {
					$(item)
						.removeClass("color-background-1")
						.removeClass("color-background-4")
						.addClass(colorScheme);
				});
				syncHomeSlideshowHeader(activeSlide);
			}
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		slideshow();
		document.addEventListener("shopify:section:load", function () {
			slideshow();
		});
		document.addEventListener("shopify:section:unload", function (event) {
			const target = event.target;
			if (target && typeof target.querySelectorAll === "function") {
				postToYoutubeIframes(target, "pauseVideo");
				target.querySelectorAll(".js-slideshow-background-video").forEach(function (video) {
					video.pause();
				});
			}
		});
	});
})();
